import React from "react";
import Card from "../../ui/Card";
import Skeleton from "../../ui/Skeleton";

const SentimentAnalysisSkeleton: React.FC = () => {
  return (
    <div className="space-y-2 animate-pulse">
      {/* Header section — mesma geometria da barra de título de página real
          (rounded-2xl, sem box de ícone, sem borda inferior). */}
      <div className="flex items-center gap-3 min-h-[52px] bg-white/70 border border-purple-200 rounded-2xl px-4 sm:px-5 py-2.5 shadow-xs">
        <Skeleton
          variant="rectangular"
          width={20}
          height={20}
          className="rounded-sm"
        />
        <div>
          <Skeleton variant="text" width={180} height={16} className="mb-1.5" />
          <Skeleton variant="text" width={220} height={12} />
        </div>
      </div>

      {/* Input Configurator */}
      <Card className="p-3 border-purple-200">
        <div className="flex flex-col lg:flex-row gap-2">
          <div className="flex-1 space-y-2">
            <Skeleton variant="text" width={150} height={14} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={96}
              className="rounded-lg"
            />
          </div>
          <div className="lg:w-80 space-y-2 flex flex-col justify-end">
            <Skeleton variant="text" width={120} height={12} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              className="rounded-lg"
            />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={44}
              className="rounded-lg"
            />
          </div>
        </div>
      </Card>

      {/* Spectrum Analysis Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="relative overflow-hidden bg-white rounded-xl border border-purple-200 p-4"
          >
            <Skeleton
              variant="rectangular"
              width="100%"
              height={3}
              className="absolute top-0 left-0 rounded-none"
            />
            <div className="flex items-start justify-between pt-0.5">
              <div className="space-y-1.5">
                <Skeleton variant="text" width={60} height={10} />
                <Skeleton variant="text" width={50} height={24} />
              </div>
              <Skeleton
                variant="rectangular"
                width={36}
                height={36}
                className="rounded-lg"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Compound Visualizer */}
      <Card className="p-3 border-purple-200">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-4">
            <Skeleton
              variant="rectangular"
              width={44}
              height={44}
              className="rounded-lg"
            />
            <Skeleton variant="text" width={200} height={16} />
          </div>
          <Skeleton
            variant="rectangular"
            width={120}
            height={26}
            className="rounded-full"
          />
        </div>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={64}
          className="rounded-xl mb-3"
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="space-y-2">
              <Skeleton variant="text" width="60%" height={10} />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={6}
                className="rounded-full"
              />
            </div>
          ))}
        </div>
      </Card>

      {/* Strategic Insights */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
        {[1, 2].map((i) => (
          <Card key={i} className="p-3 border-purple-200">
            <div className="flex items-center gap-4 mb-3">
              <Skeleton
                variant="rectangular"
                width={24}
                height={24}
                className="rounded-sm"
              />
              <Skeleton variant="text" width={180} height={16} />
            </div>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={64}
              className="rounded-xl"
            />
          </Card>
        ))}
      </div>
    </div>
  );
};

export default SentimentAnalysisSkeleton;
